import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-deceased-details-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-deceased-details-cm.component.scss?ngResource";
import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component } from "@angular/core";
import { AppControllerService } from "../../../../app-controller.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { map, of } from "rxjs";
import { DeceasedNamesTableHeaderLookup, ViewDeceasedDetailsCmConstant } from "./view-deceased-details-cm.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
export let ViewDeceasedDetailsCmComponent = class ViewDeceasedDetailsCmComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    appController;
    changeDetectorRefs;
    aflaModuleStrategyService;
    datePipe;
    selectedApplicationService;
    routerParamsService;
    nameControl = ViewDeceasedDetailsCmConstant.NAME_CONTROL;
    surnameControl = ViewDeceasedDetailsCmConstant.SURNAME_CONTROL;
    startDateControl = ViewDeceasedDetailsCmConstant.START_DATE_CONTROL;
    nameLabel = ViewDeceasedDetailsCmConstant.NAME_LABEL;
    surnameLabel = ViewDeceasedDetailsCmConstant.SURNAME_LABEL;
    startDateLabel = ViewDeceasedDetailsCmConstant.START_DATE_LABEL;
    sexLabel = ViewDeceasedDetailsCmConstant.SEX_LABEL;
    nationalityLabel = ViewDeceasedDetailsCmConstant.NATIONALITY_LABEL;
    maidenNameLabel = ViewDeceasedDetailsCmConstant.MAIDEN_NAME_LABEL;
    placeOfBirthLabel = ViewDeceasedDetailsCmConstant.PALCE_OF_BIRTH_LABEL;
    placeOfDeathLabel = ViewDeceasedDetailsCmConstant.PLACE_OF_DEATH_LABEL;
    provinceOfDeathLabel = ViewDeceasedDetailsCmConstant.PROVINCE_OF_DEATH_LABEL;
    identificationTypeLabel = ViewDeceasedDetailsCmConstant.IDENTITY_TYPE_LABEL;
    idNumberLabel = ViewDeceasedDetailsCmConstant.ID_PASSPORT_NUMBER_LABEL;
    dateOfDeathLabel = ViewDeceasedDetailsCmConstant.DATE_OF_DEATH_LABEL;
    dateOfBirthLabel = ViewDeceasedDetailsCmConstant.DATE_OF_BIRTH_LABEL;
    burialOrderNumberLabel = ViewDeceasedDetailsCmConstant.BURIAL_ORDER_LABEL;
    serialNumenerLabel = ViewDeceasedDetailsCmConstant.SERIAL_NUMBER_LABEL;
    verticalPositionLabel = ViewDeceasedDetailsCmConstant.VERTICAL_POSITION_LABEL;
    undertakerLabel = ViewDeceasedDetailsCmConstant.NAME_OF_THE_UNDERTAKER_LABEL;
    sexControl = ViewDeceasedDetailsCmConstant.SEX_CONTROL;
    nationalityControl = ViewDeceasedDetailsCmConstant.NATIONALITY_CONTROL;
    maidenNameControl = ViewDeceasedDetailsCmConstant.MAIDEN_NAME_CONTROL;
    placeOfBirthControl = ViewDeceasedDetailsCmConstant.PALCE_OF_BIRTH_CONTROL;
    placeOfDeathControl = ViewDeceasedDetailsCmConstant.PLACE_OF_DEATH_CONTROL;
    provinceOfDeathControl = ViewDeceasedDetailsCmConstant.PROVINCE_OF_DEATH_CONTROL;
    identificationTypeControl = ViewDeceasedDetailsCmConstant.IDENTITY_TYPE_CONTROL;
    idNumberControl = ViewDeceasedDetailsCmConstant.ID_PASSPORT_NUMBER_CONTROL;
    dateOfDeathControl = ViewDeceasedDetailsCmConstant.DATE_OF_DEATH_CONTROL;
    dateOfBirthControl = ViewDeceasedDetailsCmConstant.DATE_OF_BIRTH_CONTROL;
    burialOrderNumberControl = ViewDeceasedDetailsCmConstant.BURIAL_ORDER_CONTROL;
    serialNumenerControl = ViewDeceasedDetailsCmConstant.SERIAL_NUMBER_CONTROL;
    verticalPositionControl = ViewDeceasedDetailsCmConstant.VERTICAL_POSITION_CONTROL;
    undertakerControl = ViewDeceasedDetailsCmConstant.NAME_OF_THE_UNDERTAKER_CONTROL;
    validationMessages = ViewDeceasedDetailsCmConstant.VALIDATION_MESSAGES;
    title = ViewDeceasedDetailsCmConstant.DECEASED_DETAILS_TITLE;
    sexPh = ViewDeceasedDetailsCmConstant.SEX_PH;
    nationalityPh = ViewDeceasedDetailsCmConstant.NATIONALITY_PH;
    provinceOfDeathPh = ViewDeceasedDetailsCmConstant.PROVINCE_OF_DEATH_PH;
    identityTypePh = ViewDeceasedDetailsCmConstant.IDENTITY_TYPE_PH;
    verticalPositionPh = ViewDeceasedDetailsCmConstant.VERTICAL_POSITION_PH;
    deceasedForm;
    tableHeader = DeceasedNamesTableHeaderLookup;
    nationalityLookup = SharedConstants.COUNTRIES;
    tableLabel = ViewDeceasedDetailsCmConstant.TABLE_LABEL;
    provinceLookup = SharedConstants.PROVINCE;
    identificationTypeLookup = [];
    sexLookup = [];
    verticalPositionLookup = [];
    deceasedNameList;
    deceasedNameListObservable;
    lookupConst = {
        IdentificationType: "IDType",
        Sex: "Sex",
        VerticalPosition: "VerticalPosition",
    };
    constructor(applicationViewService, appController, changeDetectorRefs, aflaModuleStrategyService, datePipe, selectedApplicationService, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.datePipe = datePipe;
        this.selectedApplicationService = selectedApplicationService;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.loadLookups();
        this.listenForRouteParamChange();
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    editnamesEvent(deceasedNameList) {
        this.deceasedNameList = deceasedNameList;
        this.deceasedForm.get("deceasedNames").setValue(this.deceasedNameList);
    }
    populateForm(application) {
        Object.keys(this.deceasedForm.controls).forEach((key) => {
            this.deceasedForm.get(key).disable();
            ;
            Object.keys(application.deceased).forEach((inKey) => {
                if (key === inKey) {
                    if (inKey.indexOf("date") !== -1) {
                        const date = new Date(application.deceased[inKey]);
                        const dateString = this.datePipe.transform(date, ViewDeceasedDetailsCmConstant.DATE_CONST);
                        this.deceasedForm.get(key).setValue(dateString);
                    }
                    else
                        this.deceasedForm.get(key).setValue(application.deceased[inKey]);
                }
            });
        });
        this.deceasedNameList = application.deceased.deceasedNames;
        this.intDataSource();
    }
    initForm() {
        this.deceasedForm = this.aflaModuleStrategyService.form.get("deceasedForm");
    }
    loadLookups() {
        this.cleanupAfterDestroy(this.applicationViewService.getLookupsObservable({
            $filter: `moduleId eq ${this.appController.selectedModuleID} and name in ('${this.lookupConst.IdentificationType}','${this.lookupConst.Sex}','${this.lookupConst.VerticalPosition}') and deleted eq false`,
        })).subscribe((lookupValues) => {
            const lookup = lookupValues.value;
            lookup.forEach((lp) => {
                if (lp.name === this.lookupConst.IdentificationType)
                    this.identificationTypeLookup.push(JSON.parse(lp.content));
                if (lp.name === this.lookupConst.Sex)
                    this.sexLookup.push(JSON.parse(lp.content));
                if (lp.name === this.lookupConst.VerticalPosition)
                    this.verticalPositionLookup.push(JSON.parse(lp.content));
            });
            this.populateForm(this.selectedApplication);
            this.changeDetectorRefs.detectChanges();
        });
    }
    intDataSource() {
        this.deceasedNameListObservable = of(this.deceasedNameList)
            .pipe(map((resp) => {
            const sch = [];
            resp.forEach(el => {
                sch.push({
                    id: el.id,
                    name: el.name,
                    surname: el.surname,
                    startDate: this.datePipe.transform(el.startDate, ViewDeceasedDetailsCmConstant.SHORT_DATE_CONST)
                });
            });
            return sch;
        }));
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: AflaModuleStrategyService },
        { type: DatePipe },
        { type: SelectedApplicationService },
        { type: RouterParamsService }
    ];
};
ViewDeceasedDetailsCmComponent = __decorate([
    Component({
        selector: "app-view-deceased-details-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewDeceasedDetailsCmComponent);
